class PoOnModelWrapper extends HTMLElement {
    constructor() {
        super();
        this.onModelFaces = this.querySelectorAll('[data-model-face]');
        this.onModelWearingSizes = this.querySelectorAll('[data-wearing-size]');

        this.onConfirmSizeSelection = this.onConfirmSizeSelection.bind(this);
    }

    connectedCallback() {
        const sizeConfirmButton = document.querySelector('.js-size-confirm-btn');
        if (sizeConfirmButton) {
            sizeConfirmButton.addEventListener('click', this.onConfirmSizeSelection);
        }
    }

    disconnectedCallback() {
        const sizeConfirmButton = document.querySelector('.js-size-confirm-btn');
        if (sizeConfirmButton) {
            sizeConfirmButton.removeEventListener('click', this.onConfirmSizeSelection);
        }
    }

    onConfirmSizeSelection(e) {
        const confirmButton = e.currentTarget;
        const newFaceSize = confirmButton.getAttribute('data-option-face-id');
        const newModelSize = confirmButton.getAttribute('data-option-size-id');

        this.updateValues(newFaceSize, newModelSize);
    }

    updateValues(newFaceSize, newModelSize) {
        const capitalizeFirst = str => (str ? str.charAt(0).toUpperCase() + str.slice(1) : '');

        this.onModelFaces.forEach(face => {
            face.textContent = capitalizeFirst(newFaceSize);
        });
        this.onModelWearingSizes.forEach(size => {
            size.textContent = capitalizeFirst(newModelSize);
        });
    }
}

if (!customElements.get('po-on-model-wrapper')) {
    customElements.define('po-on-model-wrapper', PoOnModelWrapper);
}
